import { PropertiesPage } from '@/features/properties/pages/properties-page';

const PropertiesRoute = () => {
  return <PropertiesPage />;
};

export default PropertiesRoute;
